// src/lib/managers/conversation/textResponse.ts

import { generateUUID } from "../../utils/uuid/generateUUID";
import {
    ComponentData,
    ComponentDataContentType,
    ContentAction,
} from "./types/conversation";

/**
 * Réponse texte, sans liste ni bouton : le commentaire affiché et, s'il y en a une, la suggestion
 * dessous. Le texte lu est le commentaire, suivi de la suggestion (même vide) quand elle est donnée.
 */
export const buildTextResponse = (
    comment: string,
    options: { suggestion?: string; userRequestId?: string } = {},
): ComponentData => ({
    aiComment: comment,
    userRequestId: options.userRequestId ?? generateUUID(),
    content: {
        contentData: options.suggestion ?? "",
        contentType: ComponentDataContentType.FallBackResponse,
        contentAction: ContentAction.VIEW,
        upcomingAnalysis: false,
    },
    aiVocalText:
        options.suggestion === undefined
            ? comment
            : `${comment} ${options.suggestion}`,
});
